import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'activity-row-call',
  template: `
    <div class="activity-phone">
      <div *ngIf="activity.meta.callType === 'outgoing'" style="float: left; margin-right: 10px;">
        <mat-icon>call_made</mat-icon>
      </div>
      <div *ngIf="activity.meta.callType === 'incoming'" style="float: left; margin-right: 10px;">
        <mat-icon>call_received</mat-icon>
      </div>
      <div style="margin-bottom: 1%;">
        <div class="description">
          <strong>{{ activity.meta.callType.charAt(0).toUpperCase() + activity.meta.callType.slice(1) }} Phone Call&nbsp;</strong>
          <div class="text">
            <span *ngIf="activity.meta.callType === 'outgoing'">
              {{ activity.meta.caller }} called {{ activity.meta.toNumber | tel }} - {{ activity.borrowerName }}.
              <span *ngIf="!activity.meta.disposition">
                <span *ngIf="activity.meta.duration">
                  Call connected. (duration of {{ activity.meta.duration | timer }}).
                </span>
              </span>
              <span *ngIf="activity.meta.disposition && activity.meta.disposition !== 'Made contact.'">
                {{ activity.meta.disposition }}
                <span *ngIf="activity.meta.duration">(duration of {{ activity.meta.duration | timer }})</span>
              </span>
              <span *ngIf="activity.meta.disposition && activity.meta.disposition === 'Made contact.'">
                {{ activity.meta.disposition }}
                <span *ngIf="activity.meta.duration">
                  (duration of {{ activity.meta.duration | timer }}).
                  <span *ngIf="activity.meta.callTag">Call Tag: {{ activity.meta.callTag }}</span>
                </span>
              </span>
            </span>
            <span *ngIf="activity.meta.callType === 'incoming'">
              from {{ activity.meta.caller }} - {{ activity.meta.fromNumber | tel }}.
              <span *ngIf="activity.meta.duration">Call connected. (duration of {{ activity.meta.duration | timer }}).
              <span *ngIf="activity.meta.callTag">Call Tag: {{ activity.meta.callTag }}</span></span>
            </span>
          </div>
          <div style="margin-left: 2rem;">
            <span *ngIf="activity.meta.recordingUrl && activity.meta.callId">
              <a
                [href]="url"
                target="_blank"
                style="text-decoration: none; padding-left: 2px;">
                <mat-icon style="transform: translate(0px, 7px);">play_circle_outline</mat-icon>
                Listen
                <button
                  mat-stroked-button
                  color="primary">
                </button>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})

export class ActivityRowCallComponent implements OnInit {
  @Input() activity;
  url: string;

  ngOnInit(): void {
  
    const callId = this.activity.meta?.callId ?? null;
    if (callId) {
      this.url = `${environment.API_URL}/phone/recording-media/${callId}`;
    }
  }
}
